export default {
    machines: [],
    machinesLoading: false,
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters
}

function setInitialFilters() {
    return {
        name: null,
        productionDepartment_id: null,
        isVirtual: true
    }
}